import React from 'react';
import '../template-file-css/document-file-template.css';


export const RNFI_TransportationWaiver = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RNFI_TransportationWaiver' className='file-pdf-document'>
            <div className='file-template'>
                <center>
                    <h2><b>Transportation Waiver Form</b></h2>
                    <br />
                </center>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'> Consumer Name</span>
                            </td>
                            <td className='w-375'> 
                            <span className='eleHeader'>Consumer ID#</span></td>
                        

                    </tr>
                    <tr>
                    <td className='w-375'><input type='text' id='txtConsumerName' name='txtConsumerName' className='custom-add-only w-350' /></td>
                        <td className='w-375'><input type='text' id='txtConsumerId' name='txtConsumerId' className='custom-add-only w-350' /></td>

                    </tr><br />
                    <tr>
                        <td className='w-190'> I hereby give permission for</td>
                        <td className='w-200'><input type='text' id='txtConsumerId' name='txtConsumerId' placeholder='(Consumer&#39;s name)' className='custom-add-only w-200' /></td> 
                        
                        </tr>
                        <tr>
                        <td className='w-750'> To travel to and from any/all destinations for the duration of services provided by Ravens Nest Foundation, INC.</td>
                        </tr><br />
                </table>

                <p className='w-750'>I understand that the driver, vehicle owner, and Ravens Nest Foundation, INC are not responsible for any injury / damages which may be incurred on said trip, and in consideration for providing transportation, I agree to hold Ravens Nest Foundation, INC, as well as the drivers and owners of the vehicles transporting the consumer, harmless from claims for injury or damages occurring during said travel. </p><br />

                <table>
                <tr>
                        <td className='w-280'> I do not give permission for transportation</td>
                        <td className='w-470'><input type='text' id='txtPermissionTransportation' name='txtPermissionTransportation' placeholder='(Consumer&#39;s name) ' className='custom-add-only w-200' /></td>
                        
                        </tr>
                </table>

                <table>
                <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'>  (Signature of Consumer/guardian) </td>
                        <td className='small w-375'> Date: </td>
                    </tr>
                </table>




            </div>
        </form>

    )
}











